// Schema di una flow_question: objective + tipo dato + flag triggers.
import { z } from 'zod';
export const DataTypeEnum = z.enum([
    'text',
    'number',
    'choice',
    'multi_choice',
    'date',
    'scale',
    'boolean',
]);
export const FlagSeverityEnum = z.enum(['info', 'warning', 'critical']);
export const FlagToTriggerSchema = z.object({
    // Espressione semplice (Sprint 2): "answer contains X" oppure "answer == Y"
    condition: z.string().min(1).max(300),
    flag_name: z.string().min(1).max(80),
    severity: FlagSeverityEnum.default('warning'),
});
export const ChoiceSchema = z.object({
    value: z.string().min(1).max(120),
    label: z.string().min(1).max(200),
});
export const FlowQuestionSchema = z.object({
    id: z.string().uuid(),
    flow_id: z.string().uuid(),
    sort_order: z.number().int().min(0),
    objective: z.string().min(3).max(500),
    ask_examples: z.array(z.string().min(1).max(300)).max(10).default([]),
    data_type: DataTypeEnum,
    data_semantic: z.string().max(120).nullable().default(null),
    choices: z.array(ChoiceSchema).nullable().default(null),
    // Schema Zod serializzato (per Sprint 3 servirà runtime parsing)
    validation: z.unknown().nullable().default(null),
    tags: z.array(z.string().max(40)).default([]),
    flags_to_trigger: z.array(FlagToTriggerSchema).default([]),
    follow_up_if_vague: z.string().max(400).nullable().default(null),
    required: z.boolean().default(true),
    // Condizioni per saltare la domanda (vedi conditions in flow-outcome)
    skip_if: z.unknown().nullable().default(null),
});
export const FlowQuestionCreateSchema = FlowQuestionSchema.omit({
    id: true,
    flow_id: true,
});
export const FlowQuestionUpdateSchema = FlowQuestionCreateSchema.partial();
//# sourceMappingURL=flow-question.js.map